import React, { useState } from "react";
import "./style.css";
import { motion } from "framer-motion";
import StoreIcon from "@mui/icons-material/Store";
import CarRepairIcon from "@mui/icons-material/CarRepair";
import SpeedIcon from "@mui/icons-material/Speed";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import ComputerIcon from "@mui/icons-material/Computer";
import { grey } from "@mui/material/colors";
import MinorCrashOutlinedIcon from "@mui/icons-material/MinorCrashOutlined";
import ScreenSearchDesktopOutlinedIcon from "@mui/icons-material/ScreenSearchDesktopOutlined";
import ColorLensIcon from "@mui/icons-material/ColorLens";

const Card = ({ ucar, i }) => {
  // 閲覧数をローカルステートで管理
  const [views, setViews] = useState(ucar.views);

  function toJapaneseEra(year) {
    const wareki = [
      { name: "令和", start: 2019 },
      { name: "平成", start: 1989 },
      { name: "昭和", start: 1926 },
      { name: "大正", start: 1912 },
      { name: "明治", start: 1868 },
    ];

    const targetYear = parseInt(year, 10);

    for (let i = 0; i < wareki.length; i++) {
      const era = wareki[i];
      if (targetYear >= era.start) {
        const yearInEra = targetYear - era.start + 1;
        return `${era.name}${yearInEra}年`;
      }
    }

    return "不正な年号です";
  }

  async function handleClick(e) {
    e.stopPropagation(); // イベントの伝播を防ぐ

    /// ucar.siharaisogakuがNULLである場合は警告を表示して処理を終了
    if (!ucar.siharaisogaku) {
      alert("ただいまGAZOOサイト準備中です");
      return;
    }
    // ucar.siharaisogakuが存在しないか、空文字である場合は警告を表示して処理を終了
    if (ucar.comingF === "1") {
      alert("ただいまGAZOOサイト準備中です");
      return;
    }

    if (ucar.comingF === "9") {
      alert("店舗へお問い合わせください");
      return; // ここで処理を終了します
    }

    if (ucar.comingF === "2" || ucar.comingF === "3") {
      alert("商品化中です。完成までしばらくお待ちください");
      return; // ここで処理を終了します
    }
    // 新しいタブを先に開く
    const newWindow = window.open("", "_blank");

    // 条件に一致しない場合の処理
    try {
      // バックエンドのAPIを呼び出して閲覧数を増やす
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/${ucar.zaiko_id}`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const ucarData = await response.json();

      // 新しい閲覧数をステートにセット
      setViews(ucarData.views);
    } catch (error) {
      console.error("An error occurred:", error);
    } finally {
      // APIからの応答後、新しいタブのURLを設定
      newWindow.location = ucar.gazoo_url;
    }
  }

  let className = `ucarcard new-badge${Number(ucar.newFlag) ? " active" : ""}${
    ucar.comingF === "2" ? " coming2" : ""
  }${ucar.comingF === "3" ? " coming3" : ""}${
    ucar.comingF === "9" ? " coming9" : ""
  }${ucar.outlet_flag !== null ? " outlet" : ""}`;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  let eventStartDate = new Date(ucar.eventStartDate);
  eventStartDate.setHours(0, 0, 0, 0);

  let eventEndDate = new Date(ucar.eventEndDate);
  eventEndDate.setHours(0, 0, 0, 0);

  if (eventStartDate <= today && today <= eventEndDate) {
    className += " event";
  }
  return (
    <motion.div
      layout
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className='ucarcard-wraper'
      key={i}
    >
      <div className={className}>
        <div className='ucarZaikoIdValue'>在庫NO：{ucar.zaiko_id}</div>
        <button
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            color: "inherit", // ここでテキストの色を継承します
            textDecoration: "none", // 下線を削除
            display: "block", // blockレベルの要素として表示
            width: "100%", // 最大幅で表示
            textAlign: "left", // テキストを左寄せ
          }}
          onClick={handleClick}
        >
          <div className='ucarImg'>
            <img
              src={ucar.main_img}
              alt={ucar.syamei}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://corollashiga.com/ucarimg/noimage.png";
              }}
            />
          </div>

          <div className='ucarSyameiWrap'>
            <div className='makerview-wrap'>
              <div className='ucarMaker'>{ucar.maker}</div>
              <div className='view-wrap'>
                <div className='view-title'>
                  <ScreenSearchDesktopOutlinedIcon sx={{ color: grey[700] }} />
                </div>
                <div className='view'>{views}</div>
              </div>
            </div>

            <div className='ucarSyamei'>{ucar.syamei}</div>
          </div>

          <div className='ucarAllPriceWrap'>
            <div className='ucarAllPriceWrapSub'>
              <CreditCardIcon sx={{ color: grey[700] }} />
              <div className='ucarAllPriceTitle'>支払総額(税込)</div>
            </div>
            <div className='ucarAllPriceMain'>
              ￥
              {(() => {
                if (ucar.siharaisogaku) {
                  const num = Number(ucar.siharaisogaku);
                  if (!isNaN(num)) {
                    const rounded = Math.ceil(num / 1000) * 1000;

                    return rounded.toLocaleString();
                  }
                }
                return "";
              })()}
              -
            </div>
          </div>

          <div className='ucarPriceWrap'>
            <div className='ucarPriceWrapSub'>
              <CreditCardIcon sx={{ color: grey[700] }} />
              <div className='ucarPriceTitle'>車両本体価格(税込)</div>
            </div>
            <div className='ucarPriceMain'>
              ￥
              {Number(ucar.hanbaiprice)
                ? Number(ucar.hanbaiprice * 1000).toLocaleString()
                : ""}
              -
            </div>
          </div>

          {ucar.comingF !== "9" && (
            <div className='ucarKeepPriceWrap'>
              <div className='ucarKeepPriceWrapSub'>
                <MinorCrashOutlinedIcon sx={{ color: grey[700] }} />
                <div className='ucarKeepPriceTitle'>KeePerパック(税込)</div>
              </div>
              <div className='ucarKeepPriceMain'>
                ￥
                {(() => {
                  if (ucar.aplan) {
                    const num = Number(ucar.aplan);
                    if (!isNaN(num)) {
                      const rounded = Math.ceil(num / 1000) * 1000;
                      return rounded.toLocaleString();
                    }
                  }
                  return "";
                })()}
                -
              </div>
            </div>
          )}

          <div className='ucarNensikiWrap'>
            <CalendarMonthIcon sx={{ color: grey[700] }} />
            <div className='ucarNensikiTitle'>年式</div>
            <div className='ucarNensiki'>
              {ucar.nensiki.slice(0, 4)}年 (
              {toJapaneseEra(Number(ucar.nensiki.slice(0, 4)))})
            </div>
          </div>

          <div className='ucarKyoriWrap'>
            <SpeedIcon sx={{ color: grey[700] }} />
            <div className='ucarKyoriTitle'>走行距離</div>
            <div className='ucarKyori'>
              {Number(ucar.kyori).toLocaleString()}km
            </div>
          </div>

          <div className='ucarSyakenWrap'>
            <CarRepairIcon sx={{ color: grey[700] }} />
            <div className='ucarSyakenTitle'>車検</div>
            <div className='ucarSyaken'>
              {ucar.syaken ? ucar.syaken : "車検整備付"}
            </div>
          </div>

          <div className='ucarColorWrap'>
            <ColorLensIcon sx={{ color: grey[700] }} />
            <div className='ucarColorTitle'>ボディ色</div>
            <div className='ucarColor'>{ucar.color}</div>
          </div>

          <div className='ucarTenpoWrap'>
            <StoreIcon sx={{ color: grey[700] }} />
            <div className='ucarTenpoTitle'>在庫店舗</div>
            <div className='ucarTenpo'>{ucar.zaikotenpo}</div>
          </div>

          {!(
            ucar.comingF === "2" ||
            ucar.comingF === "3" ||
            ucar.comingF === "9"
          ) && (
            <div className='ucarYoyakuWrap'>
              <ComputerIcon sx={{ color: grey[700] }} />
              <div className='ucarYoyakuTitle'>予約</div>
              <div
                className={`ucarYoyaku ${
                  ucar.yoyaku === "0"
                    ? "ucarYoyakuZero"
                    : ucar.yoyaku === "1"
                    ? "ucarYoyakuOne"
                    : ucar.yoyaku === "2"
                    ? "ucarYoyakuTwo"
                    : "ucarYoyakuOther"
                }`}
              >
                {ucar.yoyaku}人
              </div>
            </div>
          )}
        </button>
      </div>
    </motion.div>
  );
};

export default Card;
